import React from 'react';
import cvData from '../../data/cv';
import { Rubric } from './Rubric';
import { CompanyMark } from './CompanyMark';
import { ChipRow } from './TechStack';
const {
  summary,
  skills,
  education,
  meta
} = cvData;
/** Profile prose — sits in the intro band. */
export function ProfileBlock({
  compact = false
}: {
  compact?: boolean;
}) {
  // Keep the fuller narrative in condensed too (trim only the closing line).
  const paras = compact ? summary.slice(0, 3) : summary;
  return <section data-id="element-17" data-mp="1eice5hztzxxo">
      <Rubric index={meta.sections.profile.index} title={meta.sections.profile.title} compact={compact} data-id="element-18" data-mp="1eim3d3d1y12b" />
      <div className={compact ? 'space-y-2' : 'space-y-3'} data-id="element-19" data-mp="1s8fvbujut1g9">
        {paras.map((p, i) => <p key={i} className="text-[12px] leading-relaxed text-[var(--ink)]" data-id="element-20" data-mp="1nbpidg3cilz2" data-mpi={i}>
            {p}
          </p>)}
      </div>
    </section>;
}
/** Capability index — sits in the intro band. */
export function CapabilitiesBlock({
  compact = false
}: {
  compact?: boolean;
}) {
  return <section data-id="element-21" data-mp="18jttyj05fz2s">
      <Rubric index={meta.sections.capabilities.index} title={meta.sections.capabilities.title} count={`${skills.length} groups`} compact={compact} data-id="element-22" data-mp="18k3j64dde27f" />
      {compact ?
    // Condensed: label ABOVE the chips so the chips flow across the FULL
    // column width (packs 2–3 per line instead of wrapping one-per-line).
    <dl className="divide-y divide-[var(--line)]" data-id="element-23" data-mp="1ri63w6yvxczf">
          {skills.map(group => <div key={group.label} className="avoid-break py-1.5 first:pt-0" data-id="element-24" data-mp="1wghfam4tvvjr">
              <dt className="mb-1 font-mono text-[8.5px] uppercase tracking-[0.16em] text-[var(--accent)]" data-id="element-25" data-mp="1weef599yom1b">
                {group.label}
              </dt>
              <dd data-id="element-26" data-mp="257rh10q06xzj">
                <ChipRow labels={group.items} data-id="element-27" data-mp="2589hyanm20ds" />
              </dd>
            </div>)}
        </dl> : <dl className="divide-y divide-[var(--line)]" data-id="element-28" data-mp="2a6b3d28iebsf">
          {skills.map(group => <div key={group.label} className="avoid-break py-3 first:pt-0" data-id="element-29" data-mp="2f4w3z2roaxhe">
              <dt className="mb-2 font-mono text-[9.5px] uppercase tracking-[0.2em] text-[var(--accent)]" data-id="element-30" data-mp="f5iunb7yzxql">
                {group.label}
              </dt>
              <dd data-id="element-31" data-mp="ovaq07nw8uw4">
                <ChipRow labels={group.items} data-id="element-32" data-mp="ovu5lhq2n76z" />
              </dd>
            </div>)}
        </dl>}
    </section>;
}
/** Education — laid out horizontally. */
export function EducationBlock({
  compact = false
}: {
  compact?: boolean;
}) {
  return <section data-id="element-33" data-mp="tu5hrz3u9tsd">
      <Rubric index={meta.sections.education.index} title={meta.sections.education.title} compact={compact} data-id="element-34" data-mp="tuexmtv66kkc" />
      <div className={`grid grid-cols-1 ${compact ? 'gap-4' : 'gap-6 sm:grid-cols-2'}`} data-id="element-35" data-mp="17t4vwctq6qaa">
        {education.map((edu, i) => <div key={i} className="cv-entry flex items-start gap-3.5" data-id="element-36" data-mp="39kro2hpcsr8c" data-mpi={i}>
            <CompanyMark company={edu.school} mark={edu.mark} domain={edu.domain} data-id="element-37" data-mp="39n45mtr78zkv" />
            <div className="min-w-0" data-id="element-38" data-mp="1k3cn5a2vbv4p">
              {edu.period && <span className="font-mono text-[11px] tabular-nums text-[var(--ink-faint)]" data-id="element-39" data-mp="1k68mn2ud6rv9">
                  {edu.period}
                </span>}
              <h3 className="font-display text-[15px] font-medium leading-snug text-[var(--ink)]" data-id="element-40" data-mp="1adjn96c394ga">
                {edu.degree}
              </h3>
              <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-[0.06em] text-[var(--accent)]" data-id="element-41" data-mp="11dei72udai5a">
                {edu.school}
              </p>
              {edu.note && <p className="mt-1 text-[11px] leading-relaxed text-[var(--ink-soft)]" data-id="element-42" data-mp="16a4xhnycl9pn">
                  {edu.note}
                </p>}
            </div>
          </div>)}
      </div>
    </section>;
}